import PlatformAnimation from './modules/PlatformAnimation';
import PlatformAnimationNew from './modules/PlatformAnimationNew';
import TextChanger from './modules/TextChanger';
import PublicationSlider from './modules/PublicationSlider';
import PipelineChart from './modules/PipelineChart';
import TeamCarousel from './modules/TeamCarousel';
import Form from './modules/Form';
import ScrollAnimation from './modules/ScrollAnimation';
import ImageTextCarousel from './modules/ImageTextCarousel';

export default {
  TextChanger,
  PlatformAnimation,
  PlatformAnimationNew,
  TeamCarousel,
  PublicationSlider,
  PipelineChart,
  Form,
  ScrollAnimation,
  ImageTextCarousel,
};
